import axios from 'axios'
import {
  Dialog,
  List,
  Loading,
  NavBar,
  Skeleton,
  Tab,
  Tabs,
  Empty,
  PullRefresh,
  Cell,
  CellGroup,
  Card,
  Col,
  Row,
  Image as VanImage,
  Toast,
  Icon,
  Popup,
  Button
} from 'vant'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './utils/store'

Vue
  .use(NavBar)
  .use(Loading)
  .use(List)
  .use(Cell)
  .use(CellGroup)
  .use(Skeleton)
  .use(Dialog)
  .use(Tab)
  .use(Tabs)
  .use(Empty)
  .use(PullRefresh)
  .use(Card)
  .use(Row)
  .use(Col)
  .use(VanImage)
  .use(Icon)
  .use(Popup)
  .use(Button)

Vue.prototype.$toast = Toast
Vue.prototype.$dialog = Dialog
Vue.prototype.$alert = Dialog.alert
Vue.prototype.$confirm = Dialog.confirm

// axios.defaults.baseURL = 'http://localhost:8080/'
axios.defaults.baseURL = 'https://www.jianerkanggz.com/docan/'
// axios.defaults.baseURL = 'http://shmily.natapp1.cc/'
axios.interceptors.request.use(config => {
  // TODO 对接
  return config
})
Vue.prototype.$http = axios
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#jianerkang-app')
